import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import { ListMultipleArtistsReleases, ListMultipleArtistsReleasesSuccess, ListMultipleArtistsReleasesError } from '../action-creators';
import { LIST_MULTIPLE_ARTIST_RELEASES } from '../actions';


export const listMultipleArtistsReleasesEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ListMultipleArtistsReleases>(LIST_MULTIPLE_ARTIST_RELEASES),
    mergeMap(async (action) => {
      try {
        if (action.ids.length) {
          const releases = await release.list(action.ids.join(','));

          return new ListMultipleArtistsReleasesSuccess(action.ids, releases);
        }

        return new ListMultipleArtistsReleasesSuccess(action.ids, []);
      } catch (err) {
        return new ListMultipleArtistsReleasesError(err.message)
      }
    })
  );